import { makeStyles } from '@material-ui/core';

export const useArcoLawExercisesStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    marginTop: 16,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
  boxContainer: {
    paddingLeft: (props) => (props.mobile ? 8 : 25),
    paddingRight: (props) => (props.mobile ? 8 : 25),
    boxSizing: 'border-box',
  },
}));
